export const ActionTypes = {
  DASHBOARD_GET_IMAGE_OPTIONS: 'DASHBOARD_GET_IMAGE_OPTIONS',
  DASHBOARD_SET_IMAGE_OPTIONS: 'DASHBOARD_SET_IMAGE_OPTIONS',
  DASHBOARD_GET_PERMISSION_OPTIONS: 'DASHBOARD_GET_PERMISSION_OPTIONS',
  DASHBOARD_SET_PERMISSION_OPTIONS: 'DASHBOARD_SET_PERMISSION_OPTIONS',
  DASHBOARD_GET_WIDGET_TYPES: 'DASHBOARD_GET_WIDGET_TYPES',
  DASHBOARD_SET_WIDGET_TYPES: 'DASHBOARD_SET_WIDGET_TYPES',
  DASHBOARD_UPDATE_MODAL_FORM_DATA: 'DASHBOARD_UPDATE_MODAL_FORM_DATA',
  DASHBOARD_PUBLISH: 'DASHBOARD_PUBLISH',
  DASHBOARD_GET_ALL: 'DASHBOARD_GET_ALL',
  DASHBOARD_SET_ALL: 'DASHBOARD_SET_ALL',
  DASHBOARD_DELETE: 'DASHBOARD_DELETE',
  DASHBOARD_RESET_ALL: 'DASHBOARD_RESET_ALL',
  DASHBOARD_GET_ALL_DEVICES: 'DASHBOARD_GET_ALL_DEVICES',
  DASHBOARD_GET_ALL_DEVICES_ERROR: 'DASHBOARD_GET_ALL_DEVICES_ERROR',
  DASHBOARD_GET_ALL_DEVICES_SUCCESS: 'DASHBOARD_GET_ALL_DEVICES_SUCCESS',
  DASHBOARD_ADD_TO_FAVORITE: 'DASHBOARD_ADD_TO_FAVORITE',
  DASHBOARD_REMOVE_FROM_FAVORITES: 'DASHBOARD_REMOVE_FROM_FAVORITES',
  DASHBOARD_GET_OS_PATHS: 'DASHBOARD_GET_OS_PATHS',
  DASHBOARD_SET_OS_PATHS: 'DASHBOARD_SET_OS_PATHS',
  DASHBOARD_GET_OS_MAP: 'DASHBOARD_GET_OS_MAP',
  DASHBOARD_SET_OS_MAP: 'DASHBOARD_SET_OS_MAP',
  DASHBOARD_CLONE: 'DASHBOARD_CLONE',
  SET_HIGHLIGHTED_DASHBOARD: 'SET_HIGHLIGHTED_DASHBOARD',
  CLEAR_HIGHLIGHTED_DASHBOARD: 'CLEAR_HIGHLIGHTED_DASHBOARD',
  DASHBOARD_GET_SCHEDULES_START: 'DASHBOARD_GET_SCHEDULES_START',
  DASHBOARD_GET_SCHEDULES_SUCCESS: 'DASHBOARD_GET_SCHEDULES_SUCCESS',
  SCHEDULES_ERROR: 'SCHEDULES_ERROR',
  DASHBOARD_GET_FUTURE_SCHEDULES_START: 'DASHBOARD_GET_FUTURE_SCHEDULES_START',
  DASHBOARD_GET_FUTURE_SCHEDULES_SUCCESS: 'DASHBOARD_GET_FUTURE_SCHEDULES_SUCCESS',
  DASHBOARD_GET_PAST_SCHEDULES_START: 'DASHBOARD_GET_PAST_SCHEDULES_START',
  DASHBOARD_GET_PAST_SCHEDULES_SUCCESS: 'DASHBOARD_GET_PAST_SCHEDULES_SUCCESS',
  FETCHING_DASHBOARDS: 'FETCHING_DASHBOARDS',
  REORDER_FAVORITE_DASHBOARDS: 'REORDER_FAVORITE_DASHBOARDS',
  SET_FAVORITE_DASHBOARDS: 'SET_FAVORITE_DASHBOARDS',
  DASHBOARD_SET_PUBLISHING_STATUS: 'DASHBOARD_SET_PUBLISHING_STATUS',
  DASHBOARD_SET_EXPORT_MODE: 'DASHBOARD_SET_EXPORT_MODE',
  SET_NUMBER_OF_DASHBOARDS_FOR_EXPORT: 'SET_NUMBER_OF_DASHBOARDS_FOR_EXPORT',
  ADD_DASHBOARD_FOR_EXPORT: 'ADD_DASHBOARD_FOR_EXPORT',
  REMOVE_DASHBOARD_FOR_EXPORT: 'REMOVE_DASHBOARD_FOR_EXPORT',
  REMOVE_ALL_DASHBOARDS_FOR_EXPORT: 'REMOVE_ALL_DASHBOARDS_FOR_EXPORT',
  DASHBOARDS_IMPORT: 'DASHBOARDS_IMPORT',
  DASHBOARDS_EXPORT: 'DASHBOARDS_EXPORT',
};

export function updateModalFormData(dispatch, data, prop) {
  dispatch({
    type: ActionTypes.DASHBOARD_UPDATE_MODAL_FORM_DATA,
    data,
    prop,
  });
}

export function publishDashboard(dispatch, history, id, dashboard, queryParams, widgetTypes) {
  dispatch({
    type: ActionTypes.DASHBOARD_PUBLISH,
    history,
    id,
    dashboard,
    queryParams,
    widgetTypes,
  });
}

export function cloneDashboard(dispatch, data, queryParams, history) {
  dispatch({
    type: ActionTypes.DASHBOARD_CLONE,
    data,
    queryParams,
    history,
  });
}

export function getImageOptions(dispatch) {
  dispatch({
    type: ActionTypes.DASHBOARD_GET_IMAGE_OPTIONS,
  });
}

export function getPermissionOptions(dispatch) {
  dispatch({
    type: ActionTypes.DASHBOARD_GET_PERMISSION_OPTIONS,
  });
}

export function getWidgetTypes(dispatch, query) {
  dispatch({
    type: ActionTypes.DASHBOARD_GET_WIDGET_TYPES,
    query,
  });
}

export function getAllDashboards(dispatch, queryParams) {
  dispatch({
    type: ActionTypes.DASHBOARD_GET_ALL,
    queryParams,
  });
}

export function getAllDevices(dispatch) {
  dispatch({
    type: ActionTypes.DASHBOARD_GET_ALL_DEVICES,
  });
}

export function deleteDashboard(dispatch, dashboard, query) {
  dispatch({
    type: ActionTypes.DASHBOARD_DELETE,
    dashboard,
    query,
  });
}

export function resetAll(dispatch) {
  dispatch({
    type: ActionTypes.DASHBOARD_RESET_ALL,
  });
}

export function toggleDashboardFavorite(dispatch, isFavorite) {
  dispatch({
    type: ActionTypes.DASHBOARD_TOGGLE_FAVORITE,
    isFavorite,
  });
}

export function addDashboardToFavorite(dispatch, dashboard, queryParams) {
  dispatch({
    type: ActionTypes.DASHBOARD_ADD_TO_FAVORITE,
    dashboard,
    queryParams,
  });
}

export function removeDashboardFromFavorites(dispatch, dashboard, queryParams) {
  dispatch({
    type: ActionTypes.DASHBOARD_REMOVE_FROM_FAVORITES,
    dashboard,
    queryParams,
  });
}

export function getSchedulesStart(dispatch, query) {
  dispatch({
    type: ActionTypes.DASHBOARD_GET_SCHEDULES_START,
    payload: query,
  });
}

export function getSchedulesSuccess(schedulesFeed) {
  return {
    type: ActionTypes.DASHBOARD_GET_SCHEDULES_SUCCESS,
    payload: schedulesFeed,
  };
}

export function getSchedulesError(error) {
  return {
    type: ActionTypes.SCHEDULES_ERROR,
    data: error,
  };
}

export function getFutureSchedulesStart(dispatch, query) {
  dispatch({
    type: ActionTypes.DASHBOARD_GET_FUTURE_SCHEDULES_START,
    payload: query,
  });
}

export function getFutureSchedulesSuccess(futureSchedulesFeed) {
  return {
    type: ActionTypes.DASHBOARD_GET_FUTURE_SCHEDULES_SUCCESS,
    payload: futureSchedulesFeed,
  };
}

export function getPastSchedulesStart(dispatch, query) {
  dispatch({
    type: ActionTypes.DASHBOARD_GET_PAST_SCHEDULES_START,
    payload: query,
  });
}

export function getPastSchedulesSuccess(pastSchedulesFeed) {
  return {
    type: ActionTypes.DASHBOARD_GET_PAST_SCHEDULES_SUCCESS,
    payload: pastSchedulesFeed,
  };
}

export function getOsPaths(dispatch) {
  dispatch({
    type: ActionTypes.DASHBOARD_GET_OS_PATHS,
  });
}

export function getOsMap(dispatch) {
  dispatch({
    type: ActionTypes.DASHBOARD_GET_OS_MAP,
  });
}

export function clearHighlightedDashboard(dispatch) {
  dispatch({
    type: ActionTypes.CLEAR_HIGHLIGHTED_DASHBOARD,
  });
}

export function reorderFavoriteDashboards(dispatch, dashboards) {
  dispatch({
    type: ActionTypes.REORDER_FAVORITE_DASHBOARDS,
    dashboards,
  });
}

export function setDashboardExportMode(dispatch, isExportMode) {
  dispatch({
    type: ActionTypes.DASHBOARD_SET_EXPORT_MODE,
    isExportMode,
  });
}

export function addDashboardForExport(dispatch, dashboardData) {
  dispatch({
    type: ActionTypes.ADD_DASHBOARD_FOR_EXPORT,
    dashboardData,
  });
}

export function removeDashboardForExport(dispatch, dashboardId) {
  dispatch({
    type: ActionTypes.REMOVE_DASHBOARD_FOR_EXPORT,
    dashboardId,
  });
}

export function removeAllDashboardsForExport(dispatch) {
  dispatch({
    type: ActionTypes.REMOVE_ALL_DASHBOARDS_FOR_EXPORT,
  });
}

export function importDashboards(dispatch, dashboards) {
  dispatch({
    type: ActionTypes.DASHBOARDS_IMPORT,
    dashboards,
  });
}

export function exportDashboards(dispatch, dashboards) {
  dispatch({
    type: ActionTypes.DASHBOARDS_EXPORT,
    dashboards,
  });
}
